import { useMediaQuery } from './hooks'
// @ts-ignore
import { breakpoints } from 'cms-web-styleguide/dist/utils/constants'
import type { FC, PropsWithChildren } from 'react'

interface MediaQueryProps extends PropsWithChildren {
  min?: number
  max?: number
}

const MediaQuery: FC<MediaQueryProps> = (props) => {
  const { children, min, max } = props

  const isAppropriateSize = useMediaQuery(breakpoints[min], breakpoints[max])

  if (isAppropriateSize) {
    return <>{children}</>
  }

  return null
}

export default MediaQuery
